"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloudConfigRateLimit = exports.RateLimitConfig = exports.RateLimitResource = void 0;
const zod_1 = __importDefault(require("zod"));
exports.RateLimitResource = zod_1.default.enum([
    "ingestion",
    "media-upload",
    "public-api",
    "public-api-legacy",
    "public-api-metrics",
    "public-api-v2-metrics",
    "public-api-daily-metrics-legacy",
    "prompts",
    "legacy-ingestion",
    "datasets",
    "trace-delete",
    "score-delete",
    "in-app-agent-run",
]);
exports.RateLimitConfig = zod_1.default.object({
    points: zod_1.default.number().nullish(),
    durationInSec: zod_1.default.number().nullish(),
    resource: exports.RateLimitResource,
});
exports.CloudConfigRateLimit = zod_1.default.array(exports.RateLimitConfig);
